/* eslint-disable @next/next/no-img-element */
import { useAmp } from 'next/amp';
import React, { useEffect, useState } from 'react';

function SidebarContent({ importPrefix, onChange, setMenuOpen }) {
  const isAmp = useAmp();
  const [opened, setOpened] = useState(null);

  const getClass = (className = '', index) => {
    if (isAmp) return '';
    const isOpened = index === opened ? ' opened' : '';

    return className + isOpened;
  };

  useEffect(() => {
    if (onChange) {
      onChange(opened);
    }
  }, [opened, onChange]);

  return (
    <ul
      className="sidebar-wrapper"
      onClick={() => {
        setMenuOpen(false);
      }}
    >
      <li>
        <div className="sidebar-item-container">
          <a href="#rastreadores-o-que-e" id="">
            O que é?
          </a>
          <img
            src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
            alt="Ícone de seta para a direita"
            height="16"
            width="16"
            className="arrow"
          />
        </div>
      </li>

      <li>
        <div className="sidebar-item-container">
          <a href="#rastreadores-parcerias" id="">
            Parceiras
          </a>

          <img
            src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
            alt="Ícone de seta para a direita"
            height="16"
            width="16"
            className="arrow"
          />
        </div>
      </li>
      {/* <li>
        <div className="sidebar-item-container">
          <a href="#rastreadores-como-contratar" id="">
            Como contratar
          </a>

          <img
            src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
            alt="Ícone de seta para a direita"
            height="16"
            width="16"
            className="arrow"
          />
        </div>
      </li> */}
      <li>
        <div className="sidebar-item-container">
          <a href="#rastreadores-formulario" id="">
            Formulário
          </a>

          <img
            src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
            alt="Ícone de seta para a direita"
            height="16"
            width="16"
            className="arrow"
          />
        </div>
      </li>
      <li>
        <div className="sidebar-item-container">
          <a href="#rastreadores-Contato" id="">
            Contatos
          </a>

          <img
            src={`${importPrefix}static/amp/shared/assets/ic_arrow_r.svg`}
            alt="Ícone de seta para a direita"
            height="16"
            width="16"
            className="arrow"
          />
        </div>
      </li>
    </ul>
  );
}

export default SidebarContent;
